import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const ADTECH_BANNERS = apiPromiseTypes('adtech-v2', 'post');
